export default "__VITE_ASSET__Uq7i6t90__"